/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ImgItem from '@/components/ImgItem';
import NumEdit from './NumEdit';
import defaultImg from '@/resources/images/mall/default_wanjia.jpg';
export default {
  props: {
    itemObj: {
      type: Object,
      "default": function _default() {
        return {
          hot: true
        };
      }
    },
    priceShow: {
      type: String,
      "default": 'right'
    },
    canMinus: {
      type: Boolean,
      "default": false
    },
    canPlus: {
      type: Boolean,
      "default": true
    },
    invalidStatus: {
      type: [String, Number]
    },
    check2: Boolean
  },
  components: {
    ImgItem: ImgItem,
    NumEdit: NumEdit
  },
  computed: {
    check: function check() {
      return this.itemObj.checked;
    },
    inventory: function inventory() {
      var _this = this;

      var goodsSpecifitionList = this.itemObj.goodsSpecifitionList;
      var nowItem = goodsSpecifitionList.find(function (x) {
        return x.goodsDetailId == _this.itemObj.goodsSpecifitionId;
      });

      if (nowItem) {
        return nowItem.inventory;
      }

      return '';
    },
    invalidStr: function invalidStr() {
      if (this.invalidStatus == 1) {
        return '已下架';
      } else if (this.inventory == 0) {
        return '已售罄';
      }
    }
  },
  watch: {
    check2: function check2(val) {
      console.log('check:  ');
      this.checked = val;
    }
  },
  data: function data() {
    return {
      testImg: 'https://ss1.bdstatic.com/70cFvXSh_Q1YnxGkpoWK1HF6hhy/it/u=1626039801,2689375718&fm=27&gp=0.jpg',
      defaultImg: defaultImg,
      checked: false
    };
  },
  created: function created() {// if(this.itemObj.checked){
    // 	this.checked = this.itemObj.checked;			
    // }
  },
  methods: {
    radioDone: function radioDone() {
      var item = this.itemObj;
      this.checked = !this.checked;
      item.checked = this.checked;
      this.$emit('radioChecked', item);
    },
    speciDone: function speciDone(goodsSpecifitionId, len) {
      var item = this.itemObj;

      if (len <= 1) {
        return;
      }

      this.$emit('cartSpec', [item, 'spec']);
    },
    numChange: function numChange(num) {
      var item = this.itemObj;
      item.goodsQtyBefore = num[1];
      item.goodsQty = num[0];
      this.$emit('cartSpec', [item, 'num']);
    },
    goDetail: function goDetail(goodsId) {
      if (this.invalidStatus == 1) {
        return;
      }

      this.$router.push({
        name: 'MallGoodsDetail',
        query: {
          goodsId: goodsId
        }
      });
    }
  }
};